import checkerboard from '@components/checkerboard';
import { Box } from '@mui/material';
import React from 'react';

const ColorBox = ({ color }: { color: string }) => (
	<Box
		width={16}
		height={16}
		sx={{
			background: checkerboard,
			backgroundColor: color,
			position: 'relative',
			'&:after': {
				content: '""',
				width: '100%',
				height: '100%',
				top: 0,
				left: 0,
				position: 'absolute',
				backgroundColor: color
			}
		}}
		border={1}
	/>
);

export default ColorBox;
